import { useEffect, useState } from "react";
import { X, Share, Plus, Download } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("pokedrop_install_dismissed")) return;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone) return;

    const ios = /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
    setIsIOS(ios);

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    if (ios) {
      const t = setTimeout(() => setShow(true), 2500);
      return () => { window.removeEventListener("beforeinstallprompt", handler); clearTimeout(t); };
    }
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("pokedrop_install_dismissed", "1");
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-20 md:bottom-6 left-4 right-4 md:left-auto md:right-6 md:max-w-sm z-[60] animate-rise" data-testid="install-prompt">
      <div className="glass rounded-2xl border border-gold/30 p-4 gold-glow">
        <button onClick={dismiss} className="absolute top-3 right-3 text-slate-400 hover:text-white" data-testid="install-dismiss">
          <X className="w-4 h-4" />
        </button>
        <div className="flex items-start gap-3">
          <img src="/icon-192.png" alt="" className="w-11 h-11 rounded-xl" />
          <div className="flex-1 pr-4">
            <p className="font-display font-bold text-white text-sm">Add PokeDrop to your Home Screen</p>
            {isIOS ? (
              <p className="text-xs text-slate-300 mt-1 leading-relaxed">
                Tap <Share className="w-3.5 h-3.5 inline text-gold" /> <b>Share</b>, then
                <b> Add to Home Screen</b> <Plus className="w-3.5 h-3.5 inline text-gold" /> to launch it full-screen like an app.
              </p>
            ) : (
              <>
                <p className="text-xs text-slate-300 mt-1">Install it and use it like a native app — full screen, one tap away.</p>
                <button onClick={install} className="mt-3 gold-gradient text-obsidian font-bold text-sm px-4 py-2 rounded-lg flex items-center gap-2" data-testid="install-button">
                  <Download className="w-4 h-4" /> Install App
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
